import { Alert, AlertIcon, Box, FormControl, FormLabel, HStack, Icon, Select, Text } from '@chakra-ui/react';
import React, { Fragment, useEffect, useState } from 'react';
import { getTemplatesQuery } from '../helpers/FlowQueries';
import { useQuery } from 'react-query';
import _ from 'lodash';
import FlowEditService from '../helpers/FlowEditService';
import { prepareEmailProviderData, prepareFlowActionTemplatesList, prepareWhatsappProviderData } from '../../../_helpers/data_helper';
import { Link } from 'react-router-dom';
import { BiRefresh } from 'react-icons/bi';
import ExportCustomAudience from '../../Audience/ExportCustomAudience';
import { fetchEmailChannels, getChanneldata } from '../../../Services/api';

export default function InspectorForAction({
    formData,
    selectedElement,
    updateFormData,
    validateFormData,
    selectedAdAccount,
    setSelectedAdAccount,
    customAudienceList,
    setCustomAudienceList,
    hasAdAccount,
    setHasAdAccount,
    hasCustomAudience,
    setHasCustomAudience,
    isFbConnected,
    setIsFbConnected,
    adAccountsList,
    setAdAccountsList,
    customAudience,
    setCustomAudience
}) {

    const orgToken = JSON.parse(localStorage.getItem('selectedOrg')).token;

    const fetchTemplates = async (path, providerUuid) => {
        if (selectedElement.actionType === 'whatsapp') {
            path += '?providerUuid=' + providerUuid;
        }
        let res = await FlowEditService.getTemplatesForAction(path);
        return prepareFlowActionTemplatesList(res.data);
    };

    const { data, isLoading, error, refetch } = useQuery(
        selectedElement.actionType,
        () => {
            if (selectedElement.actionType === 'meta') {
                return;
            } else if (selectedElement.actionType === 'whatsapp' && !!formData[selectedElement.id].action?.providerUuid) {
                return fetchTemplates(selectedElement.templatesFetchUrl, formData[selectedElement.id].action?.providerUuid);
            } else {
                return fetchTemplates(selectedElement.templatesFetchUrl);
            }
        },
        {
            enabled: selectedElement.actionType !== 'whatsapp' || !!formData[selectedElement.id].action?.providerUuid,
        }
    );

    const emailProvidersQuery = useQuery(['gatways'], {
        queryFn: async () => {
            let emailProviders = await fetchEmailChannels(orgToken);
            let tempFormData = { ...formData };
            tempFormData[selectedElement.id].action.selectedSmtpUuid = emailProviders?.data?.data[0]?.uuid;
            updateFormData(tempFormData);
            return emailProviders?.data?.data;
        },
        enabled: selectedElement.actionType == 'email',
    });

    const createTemplateLinks = {
        email: '/email/edit',
        whatsapp: '/whatsapp/create',
        sms: '/sms/create',
        push: '/push/list',
        onsite: '/nudge/layout',
        appPush: '/mobilepush/create',
        webhook: '/settings/webhook',
    };

    const selectTemplate = (e) => {
        let tempFormData = { ...formData };
        try {
            tempFormData[selectedElement.id].action.templateUUID = e?.target?.value || e;
            // selectedAdAccount is already saved inside the encoded data from ExportCustomAudience
        } catch (e) { }
        updateFormData(tempFormData);
        validateFormData('beginsWith');
    };

    const selectSetting = (e) => {
        let tempFormData = { ...formData };
        try {
            tempFormData[selectedElement.id].action['providerUuid'] = e?.target?.value;
            refetch();
        } catch (e) { }
        updateFormData(tempFormData);
        validateFormData('beginsWith');
    };

    const whatsappProviderQuery = useQuery(['providers'], {
        queryFn: async () => {
            let whatsappProviders = await getChanneldata(orgToken);
            return whatsappProviders?.data?.data?.response;
        },
        enabled: true,
    });

    useEffect(() => {
        if (selectedElement?.actionType === 'whatsapp' && whatsappProviderQuery.data) {
            const providers = prepareWhatsappProviderData(whatsappProviderQuery.data);
            if (providers.length > 0) {
                const firstProvider = providers[0].value;
                let tempFormData = { ...formData };
                tempFormData[selectedElement.id].action['providerUuid'] = firstProvider;
                updateFormData(tempFormData);
                refetch();
            }
        }
    }, [whatsappProviderQuery.data]);

    // ✅ RESTORE META VALUES WHEN EDITING FLOW
    useEffect(() => {
        if (selectedElement?.actionType === 'meta' && formData[selectedElement.id]?.action?.templateUUID) {
            try {
                const actionData = formData[selectedElement.id].action;
                const decoded = JSON.parse(atob(actionData.templateUUID));

                if (decoded?.newCustomAudienceData?.selectedAdAccount) {
                    const adAcc = decoded.newCustomAudienceData.selectedAdAccount;

                    setSelectedAdAccount(adAcc);
                    setHasAdAccount(true);

                    setCustomAudience((prevState) => ({
                        ...prevState,
                        create: decoded.newCustomAudienceData.isNew,
                        selected: decoded.newCustomAudienceData.isNew
                            ? null
                            : { id: decoded.newCustomAudienceData.customAudienceId },
                        newCustomAudienceData: {
                            name: decoded.newCustomAudienceData.name || '',
                            description: decoded.newCustomAudienceData.description || '',
                        },
                    }));
                }
            } catch (e) {
                console.error("Error restoring meta audience data:", e);
            }
        }
    }, [formData, selectedElement?.id]);

    const handleRefresh = async () => {
        try {
            await refetch();
            let tempFormData = { ...formData };
            if (data?.templates?.length) {
                const currentTemplateUUID = tempFormData[selectedElement.id]?.action?.templateUUID;
                const templateExists = data.templates.some((template) => template.uuid === currentTemplateUUID);
                if (!templateExists) {
                    tempFormData[selectedElement.id].action.templateUUID = '';
                }
            } else {
                tempFormData[selectedElement.id].action.templateUUID = '';
            }
            updateFormData(tempFormData);
            validateFormData('beginsWith');
        } catch (e) {
            console.error('Error refreshing templates:', e);
        }
    };

    if (isLoading && selectedElement.actionType !== 'meta' && selectedElement.actionType !== 'whatsapp')
        return <Text>Loading....</Text>;
    if (error && selectedElement.actionType !== 'meta' && selectedElement.actionType !== 'whatsapp')
        return <Text>Error....</Text>;

    return (
        <Fragment>
            {!!data && !data?.hasAccess && (
                <Alert status="warning">
                    <AlertIcon />
                    You do not have access to this feature. To get this feature please contact us at {JSON.parse(sessionStorage.whiteLabel).data?.email}
                </Alert>
            )}

            {selectedElement?.actionType === 'email' && !!emailProvidersQuery?.data?.length && (
                <FormControl mt={3}>
                    <FormLabel color={'inputLabel'}>SMTP Settings</FormLabel>
                    <Select
                        value={formData[selectedElement.id]?.action?.selectedSmtpUuid || ''}
                        onChange={(e) => {
                            let tempFormData = { ...formData };
                            tempFormData[selectedElement.id].action.selectedSmtpUuid = e.target.value;
                            updateFormData(tempFormData);
                        }}
                    >
                        {prepareEmailProviderData(emailProvidersQuery?.data)?.map((provider) => (
                            <option key={provider.value} value={provider.value}>
                                {provider.label}
                            </option>
                        ))}
                    </Select>
                </FormControl>
            )}

            {selectedElement?.actionType === 'whatsapp' && (
                <FormControl mt={3}>
                    <FormLabel color={'inputLabel'}>Whatsapp Setting</FormLabel>
                    <Select
                        onChange={selectSetting}
                        value={formData[selectedElement?.id]?.action?.providerUuid || ''}
                    >
                        {prepareWhatsappProviderData(whatsappProviderQuery.data).map((setting) => (
                            <option key={setting.value} value={setting.value}>
                                {setting.label}
                            </option>
                        ))}
                    </Select>
                </FormControl>
            )}

            {selectedElement?.actionType !== 'meta' && !!data?.templates && !!data.hasAccess && !!data.templates.length && (
                <Fragment>
                    <FormLabel color={'inputLabel'} mt={2}>
                        Select Template
                    </FormLabel>
                    <Select
                        mt={2}
                        placeholder="Select"
                        value={formData[selectedElement?.id]?.action?.templateUUID || ''}
                        onChange={selectTemplate}
                    >
                        {data.templates.map((template) => (
                            <option key={template.uuid} value={template.uuid}>
                                {template.title ? `${template.title} - ${template.name}` : template.name}
                            </option>
                        ))}
                    </Select>
                </Fragment>
            )}

            {selectedElement?.actionType !== 'meta' && !!data?.templates && !!data.hasAccess && !data.templates?.length && (
                <Alert status="warning">
                    <AlertIcon />
                    You do not have any saved templates.
                </Alert>
            )}

            {selectedElement?.actionType !== 'meta' && !!data?.hasAccess && (
                <HStack w={'100%'} justifyContent={'space-between'}>
                    <Link target="_blank" to={createTemplateLinks[selectedElement.actionType]}>
                        <Text textDecoration={'underline'} cursor={'pointer'}>
                            Create Template +
                        </Text>
                    </Link>
                    {!!formData[selectedElement?.id]?.action?.templateUUID && selectedElement?.actionType !== 'webhook' && (
                        <Text
                            as="span"
                            textDecoration="underline"
                            cursor="pointer"
                            onClick={() => {
                                const url = `${createTemplateLinks[selectedElement.actionType]}/${formData[selectedElement?.id]?.action?.templateUUID}`;
                                const state = { provider: formData[selectedElement?.id]?.action?.providerUuid };
                                const newTab = window.open(url, '_blank');
                                if (newTab) newTab.onload = () => newTab.history.pushState(state, '', url);
                            }}
                        >
                            Edit
                        </Text>
                    )}
                    {!!data?.hasAccess && (
                        <Text onClick={handleRefresh} textDecoration={'underline'} cursor={'pointer'}>
                            Refresh <Icon as={BiRefresh} />
                        </Text>
                    )}
                </HStack>
            )}

            {selectedElement?.actionType === 'meta' && (
                <Box>
                    <ExportCustomAudience
                        selectedElement={selectedElement}
                        formData={formData}
                        selectedAdAccount={selectedAdAccount}
                        setSelectedAdAccount={setSelectedAdAccount}
                        customAudienceList={customAudienceList}
                        setCustomAudienceList={setCustomAudienceList}
                        hasAdAccount={hasAdAccount}
                        setHasAdAccount={setHasAdAccount}
                        hasCustomAudience={hasCustomAudience}
                        setHasCustomAudience={setHasCustomAudience}
                        isFbConnected={isFbConnected}
                        setIsFbConnected={setIsFbConnected}
                        adAccountsList={adAccountsList}
                        setAdAccountsList={setAdAccountsList}
                        customAudience={customAudience}
                        setCustomAudience={setCustomAudience}
                        selectTemplate={selectTemplate}
                        segmentId={formData['beginsWith']?.nextActionCondition?.criteria[0]?.selectedSegmentId}
                    />
                </Box>
            )}
        </Fragment>
    );
}